import { getIvivoOrders, createIvivoOrder, updateIvivoOrder, deleteIvivoOrder, getIvivoOrdersFull } from '../models/ivivoOrdersModel.js';
import Swal from 'sweetalert2';
import pb from '../lib/pocketbase';
import { toasts } from "svelte-toasts";

export async function fetchIvivoOrders({ page = 1, perPage = 50, processed = null, startDate = null, endDate = null } = {}) {
  try {
    let filters = [];
    if (processed !== null) filters.push(`processed = ${processed}`);
    if (startDate) filters.push(`orderDate >= '${startDate}'`);
    if (endDate) filters.push(`orderDate <= '${endDate}T23:59:59'`);
    const filterStr = filters.length ? filters.join(' && ') : '';
    const response = await getIvivoOrders(page, perPage, filterStr);
    return {
      ivivoOrders: response.items,
      totalRecords: response.totalItems,
      currentPage: response.page,
    };
  } catch (error) {
    console.error("Error fetching iVivo orders:", error);
    Swal.fire('Error', 'No se pudieron cargar los resultados de iVivo', 'error');
    return null;
  }
}

export async function saveIvivoOrder(order, currentOrderId) {
  try {
    if (currentOrderId) {
      await updateIvivoOrder(currentOrderId, order);
      toasts.add({
        title: 'Éxito',
        description: 'Orden iVivo guardada exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
    } else {
      await createIvivoOrder(order);
      toasts.add({
        title: 'Éxito',
        description: 'Orden iVivo creada exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
    }
  } catch (error) {
    console.error("Error saving iVivo order:", error);
    toasts.add({
      title: 'Error',
      description: 'Ocurrió un error al guardar la orden iVivo',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true
    });
  }
}

export async function removeIvivoOrder(id) {
  try {
    await deleteIvivoOrder(id);
    toasts.add({
      title: 'Éxito',
      description: 'Orden iVivo eliminada exitosamente.',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true
    });
  } catch (error) {
    console.error("Error deleting iVivo order:", error);
    Swal.fire('Error', 'No se pudo eliminar la orden iVivo', 'error');
  }
}

export async function searchIvivoOrders(query, page = 1, perPage = 10) {
  const response = await getIvivoOrders(page, perPage, `ecwidOrder ~ "${query}" || ivivoId ~ "${query}"`);
  return {
    ivivoOrders: response.items,
    totalRecords: response.totalItems,
    currentPage: response.currentPage,
  };
}

export async function exportIvivoOrders({ processed = null, startDate = null, endDate = null } = {}) {
  try {
    let filters = [];
    if (processed !== null) filters.push(`processed = ${processed}`);
    if (startDate) filters.push(`orderDate >= '${startDate}'`);
    if (endDate) filters.push(`orderDate <= '${endDate}T23:59:59'`);
    const filterStr = filters.length ? filters.join(' && ') : '';
    const response = await getIvivoOrdersFull(filterStr);
    return response;
  } catch (error) {
    console.error("Error exporting iVivo orders:", error);
    return null;
  }
}

// Real-time subscription (optional, if needed)
export function subscribeToIvivoOrders(handleUpdate) {
  pb.collection('ivivo_orders').subscribe('*', async (e) => {
    await handleUpdate(1);
  });
}

export function unsubscribeFromIvivoOrders() {
  pb.collection('ivivo_orders').unsubscribe('*');
} 